import styled from 'styled-components';
import { Input, Select, Button, DatePicker } from 'antd';

export const StyledSectionHeader = styled.div`
  font-weight: 600;
  font-size: ${({ theme }) => theme.font.size.small};
  margin-top: ${({ theme }) => theme.spacing.space_5};
  margin-bottom: ${({ theme }) => theme.spacing.space_4};
`;

export const StyledFieldLabel = styled.div`
  font-weight: 300;
  font-size: ${({ theme }) => theme.font.size.small};
  margin-bottom: ${({ theme }) => theme.spacing.space_2};
`;

export const StyledFieldRow = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.space_3};
  align-items: flex-start;
  margin-bottom: ${({ theme }) => theme.spacing.space_2};
`;

export const StyledNamesRow = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.space_3};
  margin-top: ${({ theme }) => theme.spacing.space_4};
  margin-bottom: ${({ theme }) => theme.spacing.space_4};
`;

export const StyledAddonSelect = styled(Select)`
  width: ${({ theme }) => theme.size.tiny};
  display: flex;
  flex-direction: row;

  .ant-select-selector {
    height: ${({ theme }) => theme.spacing.space_5} !important;
    padding-right: ${({ theme }) => theme.spacing.space_2} !important;
    padding-left: ${({ theme }) => theme.spacing.space_2} !important;
  }
`;

export const StyledInput = styled(Input)`
  width: 100%;
  height: ${({ theme }) => theme.spacing.space_5};
  margin-top: ${({ theme }) => theme.spacing.space_2};
`;

export const StyledMonthPicker = styled(DatePicker)`
  width: 100%;
  height: ${({ theme }) => theme.spacing.space_5};
  margin-top: ${({ theme }) => theme.spacing.space_2};
`;

export const StyledRemoveButton = styled(Button)`
  margin-bottom: ${({ theme }) => theme.spacing.space_2};
  align-self: center;
`;

export const StyledAddButton = styled(Button)`
  margin-bottom: ${({ theme }) => theme.spacing.space_4};
`;

export const StyledSection = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.space_4};
`;
